Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerBaselinePlannedRoute = (function () {

    function LayerBaselinePlannedRoute () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'baseline_planned_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.BaselinePlannedRoute';

        let instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = () => {
            this.setLayerStatusOnLocalStorageByTagName(this.checkBox.checked);
            if (this.checkBox.checked) {
                if (instanceToDataClass) {
                    instanceToDataClass.drawBaselinePlannedRoute();
                }
            } else {
                if (instanceToDataClass) {
                    instanceToDataClass.removeBaselinePlannedRoute();
                }
            }
        };
    }
    return LayerBaselinePlannedRoute;
})();
